import type { StateCreator } from 'zustand';
import { leadInsightsApi, type FunnelInsightSummary } from '../services/leadInsightsApi';

export interface LeadInsightsSlice {
  leadInsightsSummary: FunnelInsightSummary | null;
  leadInsightsCountry: string;
  leadInsightsLoading: boolean;
  leadInsightsExporting: boolean;
  leadInsightsError: string | null;
  setLeadInsightsCountry: (country: string) => void;
  fetchLeadInsightsSummary: () => Promise<void>;
  exportLeadInsightsCsv: () => Promise<void>;
}

export const createLeadInsightsSlice: StateCreator<LeadInsightsSlice> = (set, get) => ({
  leadInsightsSummary: null,
  leadInsightsCountry: '',
  leadInsightsLoading: false,
  leadInsightsExporting: false,
  leadInsightsError: null,

  setLeadInsightsCountry: (country) => set({ leadInsightsCountry: country }),

  fetchLeadInsightsSummary: async () => {
    set({ leadInsightsLoading: true, leadInsightsError: null });
    try {
      const summary = await leadInsightsApi.getSummary(get().leadInsightsCountry || undefined);
      set({ leadInsightsSummary: summary, leadInsightsLoading: false });
    } catch (e) {
      set({ leadInsightsError: e instanceof Error ? e.message : String(e), leadInsightsLoading: false });
    }
  },

  exportLeadInsightsCsv: async () => {
    set({ leadInsightsExporting: true, leadInsightsError: null });
    try {
      await leadInsightsApi.downloadExportCsv(get().leadInsightsCountry || undefined);
    } catch (e) {
      set({ leadInsightsError: e instanceof Error ? e.message : String(e) });
    } finally {
      set({ leadInsightsExporting: false });
    }
  },
});
